import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const Diamond2Shape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.9 341.7",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M294.5 103l-89-98.6-88 98.6zM187.6 0H70.1l36.3 91zM340.9 0H223.4l81.7 90.6zM56.8 10.1L0 103h93.8zM3.2 119l177.6 202.5L100.2 119zM117.4 119l88.7 222.7 88-222.7zM231.3 321.4L407.7 119h-96.4zM317.6 103h93.3l-56.7-92.8z"
    })
  });
};

export { Diamond2Shape };
//# sourceMappingURL=Diamond2Shape.js.map
